import type { CreatePostInput } from './graphqlTypes'
import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

import type { MapperContext } from './types'
import { mapSharedPostFields } from './mapSharedPostFields'

// Pure mapper: one legacy per-channel `Draft` (+ context) → one `CreatePostInput`.
//
// `needsApproval` is create-only (edit uses `approvalChange`), so it is set here
// rather than in the shared fields. Only `true` is sent: the field defaults to
// `false` server-side, and a `false` `requestApproval` means "withdraw", which
// has no meaning on a post that doesn't exist yet.
export function mapToCreatePostInput(
  draft: Draft,
  ctx: MapperContext,
): CreatePostInput {
  return {
    channelId: ctx.channelId,
    ...mapSharedPostFields(draft, ctx),
    ...(ctx.requestApproval === true ? { needsApproval: true } : {}),
  }
}
